var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.4@lodash/_getPrototype.js
// module id = 189
// module chunks = 1